module.exports = __webpack_public_path__ + "img/928-1b0579.png";